export default "__VITE_ASSET__BzF8x7dy__"